module.exports = __webpack_public_path__ + "img/1.aa851b1f.webp";